<template>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
          <div
            class="page-header main-image min-vw-100"
            :style="`background-image:linear-gradient(0deg, #12141B 0%, rgba(0, 20, 27, 0) 100%), url(${require('@/assets/img/rocas.jpg')}) !important; background-size: cover; background-position: 50%;`"
          >
          </div>
        </v-col>
      </v-row>
      <v-row class="margin-view margin-text-box">
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="">
          <v-card class="border-radius-xl card-dialog">
            <div class="padding-text">
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                  <h2 v-if="actualIncentive != null" class="text-white mb-5">Formulario para postularse al incentivo</h2>
                  <h2 v-if="actualIncentive != null" class="text-white mb-5 notranslate">"{{actualIncentive.contents_info.title.value}}"</h2>
                  <label class="text-white">
                    Para saber si eres candidato para recibir sus beneficios, necesitamos que registres una cuenta en nuestra plataforma y nos proporciones la información del proyecto de filmografía con el que quieres participar.
                  </label>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                  <hr class="horizontal my-4 light line_gradient_background"/>
                  <h3 class="text-white">Datos de la cuenta</h3>
                </v-col>
                <v-col cols="12" lg="4">
                  <label class="text-white">Email</label>    
                  <v-text-field
                    v-model="userData.email"
                    placeholder="ejemplo@gmail.com"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
    
                <v-col cols="12" lg="4">
                  <label class="text-white">Contraseña</label>
                  <v-text-field
                    v-model="userData.password"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    type="password"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
    
                <v-col cols="12" lg="4">
                  <label class="text-white">Confirmar contraseña</label>
                  <v-text-field
                    v-model="userData.password_confirmation"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    type="password"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
                
                <v-col cols="12" lg="4">
                  <label class="text-white">País</label>
                  <v-autocomplete
                    v-model="userData.country"
                    :items="countries"
                    item-text="country"
                    item-value="country"
                    color="white"
                    background-color="#292b31"
                    outlined
                    hide-details
                    class="text-color font-size-input input-style mb-5 input-white-text-public"
                  ></v-autocomplete>
                </v-col>
    
                <v-col cols="12" lg="4">
                  <label class="text-white">Estado</label>
                  <v-autocomplete
                    v-model="userData.state"
                    :items="states"
                    color="white"
                    background-color="#292b31"
                    outlined
                    hide-details
                    class="text-color mb-2 font-size-input input-style input-white-text-public"
                  ></v-autocomplete>
                </v-col>
    
                <v-col cols="12" lg="4">
                  <label class="text-white">Tipo de cuenta</label>
                  <v-select
                    v-model="userData.userType"
                    class="text-color mb-2 font-size-input input-style input-white-text-public"
                    hide-details
                    color="white"
                    background-color="#292b31"
                    outlined
                    :items="[
                      { name: 'Producer', name_es: 'Casa productora' }
                    ]"
                    item-value="name"
                    item-text="name_es"
                  />
                </v-col>
    
                <v-col>
                  <label class="text-white">Código de país &nbsp;</label>
                  <vue-country-code 
                    class="text-color input-style style_background country-select-code"
                    v-model="userData.phone_prefix"
                    :disabledFetchingCountry="true"
                    :enabledCountryCode="true"
                    :preferredCountries="preferredCountries"
                    @onSelect="selectCountryCode"
                  />
                </v-col>
    
                <v-col cols="12" lg="4">
                  <label class="text-white">Teléfono</label>
                  <v-text-field
                    v-model="userData.phone"
                    color="white"
                    background-color="#292b31"
                    outlined
                    mask="###.###.###-##"
                    max="10"
                    hide-details
                    class="text-color input-style mb-5 input-white-text-public"
                  ></v-text-field>
                </v-col>
    
                <v-col cols="12" lg="4">
                  <div>
                    <v-checkbox 
                      color="white"
                      v-model="userData.phone_whatsapp"
                      class="wa-checkbox-container"
                    >
                      <template v-slot:label>
                        <span style="color: white; font-weight: bold;">¿Whatsapp?</span>
                      </template>
                    </v-checkbox>
                  </div>
                </v-col>
                
                <v-col cols="12" lg="4" v-if="userData.userType == 'Provider'">
                  <label class="text-white">Registro en el padrón de proveedores</label>
                  <v-text-field
                      v-model="file.name"
                      @click="pickFile"
                      color="white"
                      background-color="#292b31"
                      readonly
                      outlined
                      hide-details
                      class="text-color input-style mb-5 input-white-text-public"
                  ></v-text-field>
                  <input accept="application/pdf" @change="getFile" style="display: none;" type="file" ref="file" class="form-control">
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                  <hr class="horizontal my-4 light line_gradient_background"/>
                  <h3 class="text-white">Datos del proyecto de filmografía</h3>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                  <label class="text-white">Nombre:</label>    
                  <v-text-field
                    v-model="newFilmProject.name"
                    placeholder="titulo"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <label class="text-white">Tipo:</label>    
                  <v-select
                    v-model="newFilmProject.film_type"
                    :items="selectFilmTypes"
                    item-text="text"
                    item-value="value"
                    color="white"
                    background-color="#292b31"
                    class="text-color mb-2 font-size-input input-style input-white-text-public"
                    outlined
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <label class="text-white">Origen:</label>    
                  <v-select
                    v-model="newFilmProject.film_origin"
                    :items="selectFilmOrigin"
                    item-text="text"
                    item-value="value"
                    color="white"
                    background-color="#292b31"
                    class="text-color mb-2 font-size-input input-style input-white-text-public"
                    outlined
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <label class="text-white">Etapa actual:</label>    
                  <v-select
                    v-model="newFilmProject.film_stage"
                    :items="selectFilmStage"
                    item-text="text"
                    item-value="value"
                    color="white"
                    background-color="#292b31"
                    class="text-color mb-2 font-size-input input-style input-white-text-public"
                    outlined
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                  <label class="text-white">Presupuesto total en Durango (USD):</label>    
                  <v-text-field
                    v-model="newFilmProject.total_budget_in_dgo"
                    type="number"
                    placeholder="000000000.00"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                  <label class="text-white">Presupuesto facturable en Durango (USD):</label>    
                  <v-text-field
                    v-model="newFilmProject.total_billiable_in_dgo"
                    type="number"
                    placeholder="000000000.00"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <label class="text-white">Dias de filmación en interiores:</label>    
                  <v-text-field
                    v-model="newFilmProject.film_days_indoors"
                    type="number"
                    placeholder="0"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <label class="text-white">Dias de filmación en exteriores:</label>    
                  <v-text-field
                    v-model="newFilmProject.film_days_outdoors"
                    type="number"
                    placeholder="0"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <label class="text-white">Dias totales de filmación en Durango:</label>    
                  <v-text-field
                    v-model="newFilmProject.total_film_days_in_dgo"
                    type="number"
                    placeholder="0"
                    color="white"
                    background-color="#292b31"
                    class="text-color input-style mb-5 input-white-text-public"
                    hide-details
                    outlined
                    clearable
                    disabled
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                <v-btn 
                  class="my-1 mx-0 button-gradient text-white text-transform-none" 
                  :loading="btnLoading"
                  @click="sendPostulation"
                >
                  Registrar postulación
                </v-btn>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>  
    </v-container>
  </template>
  <script>
  import Api from '@/api/Api';
  import axios from 'axios';
  import countries from '../../../util/countries';

  import Vue from "vue";
  import VueCountryCode from "vue-country-code";

  Vue.use(VueCountryCode);
  
  export default {
    props: {
    },
    data() {
      return {
        incentive_id: null,
        user: {
          Personal_information: {
            complete_name: "  "
          },
          Roles: [
            null
          ]
        },
        actualIncentive: {
          contents_info: {
            title: {
              value: null
            }
          }
        },

        btnLoading: false,

        selectFilmTypes: [
          {text: 'Trabajo cinematográfico', value: 'cinematographic work'},
            {text: 'Ficción/documental', value:'fiction/documental'},
          {text: 'Producto audiovisual', value: 'audiovisual product'},
          {text: 'Postproducción y VFX', value: 'postproduction & VFX'}
        ],
        selectFilmOrigin: [
          {text: 'Nacional (México)', value: 'national'},
            {text: 'Extranjero', value:'foreign'},
          {text: 'Coproducción', value: 'coproduction'}
        ],
        selectFilmStage: [
          {text: 'Pre producción', value: 'pre-production'},
            {text: 'Producción', value:'production'},
          {text: 'Post producción', value: 'post-production'}
        ],

        newFilmProject: {
          name: null,
          film_type: null,
          film_origin: null,
          film_stage: null,
          total_budget_in_dgo: 0.00,
          total_billiable_in_dgo: 0.00,
          film_days_indoors: 0,
          film_days_outdoors: 0,
          total_film_days_in_dgo: 0,
          user_id: null,
        },

        userData: {
          email: null,
          password: null,
          password_confirmation: null,
          phone_prefix: null,
          phone: null,
          phone_whatsapp: false,
          country: null,
          state: null,
          userType: 'Producer',
          files: []
        },

        file: {
          name: null,
          document: null
        },

        countries: countries,
        preferredCountries: [
          'mx',
          'us',
          'ca'
        ],
        roles: [],
        
      };
    },
    created() {
      this.$emit('navbarMainPage',false);
    },
    watch: {
      'newFilmProject.film_days_indoors' () {
        this.newFilmProject.total_film_days_in_dgo = parseInt(this.newFilmProject.film_days_indoors) + parseInt(this.newFilmProject.film_days_outdoors);
      },
      'newFilmProject.film_days_outdoors'() {
        this.newFilmProject.total_film_days_in_dgo = parseInt(this.newFilmProject.film_days_indoors) + parseInt(this.newFilmProject.film_days_outdoors);
      }
    },
    computed: {
      states() {
        if(!this.userData.country) return [];
        return this.countries.find(item => item.country == this.userData.country).states;
      }
    },
    mounted() {
      this.getUserInfo();
      this.incentive_id = this.$route.params.incentive_id;
    },
    methods: {
      getUserInfo: function () {
        Api.get('/auth/user_is_logged').then(response => {
          if (response.data === 'logged') {
            Api.get('/auth/logged_user').then(response => {
              this.user = response.data;
              this.newFilmProject.user_id = this.user.User.id;
              if (this.user.Roles[0] != 'Producer') {
                this.$swal('Acceso denegado', 'No se puede postular a un incentivo si no es una casa productora. Pruebe con otro usuario.', "error");
                this.$router.push({ 
                  name: 'Incentivos'
                })
              } else {
                this.$router.push({ 
                  name: 'Apply for incentive', 
                  params: { 
                    incentive_id: this.incentive_id
                  } 
                });
              }
            })
            .catch(error => this.errorHandling(error))
          } else {
            this.getIncentiveInfo();
          }
        })
        .catch(error => this.errorHandling(error))
      },
      getIncentiveInfo: function () {
        Api.post('/section/get_specific_contents', {
          section_id: this.incentive_id,
          contents: [
            'title'
          ]
        })
        .then(response => {
          this.actualIncentive = response.data;
        })
      },
      sendPostulation: function () {
        this.btnLoading = true;
        this.$swal({
          title: "Confirmación",
          text: "¿Desea registrar este usuario y postularse con este proyecto?",
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn bg-gradient-success",
            cancelButton: "btn bg-gradient-danger",
          },
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {

            let formData = new FormData();
            formData.append('user_fileName', this.file.name);
            formData.append('user_file', this.file.document);
            formData.append('email', this.userData.email);
            formData.append('user_password', this.userData.password);
            formData.append('user_password_confirmation', this.userData.password_confirmation);
            formData.append('user_country', this.userData.country);
            formData.append('user_state', this.userData.state);
            formData.append('user_userType', this.userData.userType);
            formData.append('user_phone_prefix', this.userData.phone_prefix);
            formData.append('user_phone', this.userData.phone);
            formData.append('user_phone_whatsapp', this.userData.phone_whatsapp);

            formData.append('project_name', this.newFilmProject.name);
            formData.append('project_film_type', this.newFilmProject.film_type);
            formData.append('project_film_origin', this.newFilmProject.film_origin);
            formData.append('project_film_stage', this.newFilmProject.film_stage);
            formData.append('project_total_budget_in_dgo', this.newFilmProject.total_budget_in_dgo);
            formData.append('project_total_billiable_in_dgo', this.newFilmProject.total_billiable_in_dgo);
            formData.append('project_film_days_indoors', this.newFilmProject.film_days_indoors);
            formData.append('project_film_days_outdoors', this.newFilmProject.film_days_outdoors);
            formData.append('project_total_film_days_in_dgo', this.newFilmProject.total_film_days_in_dgo);

            formData.append('vinculation_section_id', this.incentive_id);

            Api.post('film_project/from_new_user', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => {
              if (response.data.status == true) {
                this.$swal('¡Todo listo!', 'Se ha registrado tu postulación correctamente. Puedes consultar el estado de tu postulación desde la tabla de "postulaciones a incentivos" de tu panel de administrador (Te hemos enviado un correo de confirmación al email proporcionado. Es necesario confirmar tu correo antes de poder iniciar sesión.)', "success");
                this.navigateTo('/incentives');
              } else {
                this.$swal('', response.data.message_text, "error");
                this.btnLoading = false;
              }
            })
            .catch(error => {
              this.btnLoading = false;
              this.errorHandling(error);
            })
            .finally(() => {
              this.btnLoading = false;
            });
          } else {
            this.btnLoading = false;
          }
        });
      },
      
      async loadMoreItems({ page }) {
        try {
          this.loading = true;
          const response = await axios.get(`your-api-endpoint?page=${page}&search=${this.searchInput}`);
          this.items = [...this.items, ...response.data.items];
          this.serverItemsLength = response.data.totalItems;
          this.loading = false;
        } catch (error) {
          console.error(error);
          this.loading = false;
        }
      },
      async searchItems() {
        this.pagination.page = 1;
        await this.loadMoreItems({ page: 1 });
      },
      selectCountryCode: function ({ name, iso2, dialCode }) {
        this.userData.phone_prefix = name + iso2;
        this.userData.phone_prefix = dialCode;
      },
      selectCountry: function ({ name, iso2, dialCode }) {
        this.userData.country = dialCode + iso2;
        this.userData.country = name;
      },
      pickFile: function () {
        this.$refs.file.click();
      },
      getFile: function(e) {
        let file = e.target.files[0];
        this.file.name = file.name;
        this.file.document = file
      }
    },
  };
  </script>
  <style scoped>
    *{
      font-family: "Roboto", sans-serif !important;
    }
    .fa, .fas {
      font-family: 'Font Awesome 5 Free' !important;
    }
    .margin-view{
      margin-left: auto;
      margin-right: auto;
      max-width: 85%;
      margin-top: -10vh;
    }
    .main-image{
      min-height: 43vh;
    }
    .margin-title{
      margin-bottom: 5vh;
    }
    .button-gradient{
        background: linear-gradient(90deg, #50005E 0%, #C71C4F 100%);
    }
    .margin-button{
      margin-top: 7vh;
    }
    .margin-text-box{
      margin-bottom: 20vh;
    }
    .fa-times{
        background-image: linear-gradient(180deg, #FFB800 0%, #FF4146 53%, #FF1361 100%) !important;
        color: transparent !important; 
        background-clip: text !important;
    }
    .card-dialog{
        background: #12141b;
    }
    .padding-text{
        padding-left: 5vh;
        padding-right: 5vh;
    }
    .color-line{
        color: #FFFFFF;
    }
    .text-color >>> .v-text-field__slot input{
      color: #666b7f;
    }
  </style>